import { ThemeProvider, createTheme } from "@mui/material/styles";
import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter, Route, Routes } from "react-router";
import LoginScreen from "./features/login/login";
import DashboardScreen from "./features/dashboard/dashboard";
import LoginContextProvider from "./context/loginContextProvider";
import RequireLogin from "./components/requireLogin";
import GlobalDataContextProvider from "./context/globalDataContext";
import AddProfileScreen from "./features/add-profile/AddProfileScreen";
import { PerformanceScreen } from "./features/performance-overview/PerformanceScreen";

const darkTheme = createTheme({
  components: {
    MuiAppBar: {},
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#F06449",
    },
    secondary: {
      main: "#EDE6E3",
    },
  },
});

function Routers() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <RequireLogin>
              <GlobalDataContextProvider>
                <DashboardScreen />
              </GlobalDataContextProvider>
            </RequireLogin>
          }
        />
        <Route path="/login" element={<LoginScreen />} />
        <Route
          path="/add-profile"
          element={
            <RequireLogin>
              <AddProfileScreen />
            </RequireLogin>
          }
        />
        <Route
          path="/performance-overview"
          element={
            <RequireLogin>
              <PerformanceScreen />
            </RequireLogin>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      <LoginContextProvider>
        <Routers />
      </LoginContextProvider>
    </ThemeProvider>
  );
}

export default App;
